<template>
  <section>
    <v-dialog
      v-model="modalAction"
      max-width="1200px"
      height="800px"
      scrollable
      @keydown="executeCloseModalPreviewDocument"
      @click:outside="executeCloseModalPreviewDocument"
    >
      <v-card>
        <div class="p-4 pb-0">
          <h5>Documento {{ documentName ? documentName : "-" }}</h5>
        </div>
        <hr />
        <v-card-text>
          <div class="mx-auto text-center mt-16 mb-5" v-if="loading">
            <h5>
              {{
                reloadDocument
                  ? "Reitentando conexión... espere por favor"
                  : "Cargando"
              }}...
            </h5>
            <v-progress-circular
              :size="70"
              :width="7"
              color="primary"
              class="mx-auto mt-3"
              indeterminate
            ></v-progress-circular>
          </div>
          <div class="mx-auto text-center" style="height: 500px !important;">
            <component
              v-if="filePreview"
              id="previewDocument"
              :is="filePreview.component"
              :height="filePreview.height"
              :width="filePreview.width"
              :src="filePreview.src"
              controls
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="downloadFile">
            <v-icon> mdi-download </v-icon>
            <small> Descargar Archivo </small>
          </v-btn>

          <v-btn
            color="red darken-1"
            outlined
            @click="executeCloseModalPreviewDocument"
          >
            <small> Cerrar </small>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { preventCloseIfNotKeyEventEsc } from "@/helpers/common";
export default {
  components: {},
  props: {
    modalAction: {
      type: Boolean,
      default: false,
    },
    closeModalPreviewDocument: {
      type: Function,
      default: () => {},
    },
    documentName: {
      default: null,
    },
    currentDocument: {
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      reloadDocument: false,
      filePreview: null,
      imagesExtensions: ["png", "jpg", "jpeg", "bmp"],
      videoExtensions: ["mp4", "mov", "avi", "wmv", "flv"],
      pdfFile: "pdf",
    };
  },
  methods: {
    executeCloseModalPreviewDocument($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.closeModalPreviewDocument($event);
      }
    },
    downloadFile() {
      this.$emit("downloadFile", this.currentDocument);
    },
   async getFileAndPreview(retryCount = 0) {
      const MAX_RETRIES = 2;
      try {
        this.loading = true;
        this.filePreview = null;

        const isImage = this.imagesExtensions.includes(this.currentDocument.extension);
        const isVideo = this.videoExtensions.includes(this.currentDocument.extension);

        if (isImage || isVideo) {
          const response = await fetch(this.currentDocument.url, { method: "GET" });
          const blob = await response.blob();
          
          this.filePreview = {
            component: isImage ? "img" : "video",
            src: URL.createObjectURL(blob),
            width: isImage ? "800px" : "100%",
            height: "500px",
          };
          this.loading = false;
          
        } else {
          const encodedUrl = encodeURIComponent(this.currentDocument.url);
          const cacheBuster = retryCount > 0 ? `&t=${Date.now()}` : "";
          const gviewUrl = `https://docs.google.com/gview?url=${encodedUrl}&embedded=true${cacheBuster}`;

          this.filePreview = {
            component: "iframe",
            src: gviewUrl,
            width: "100%",
            height: "500px",
          };

          setTimeout(() => {
            const iframe = document.getElementById("previewDocument");
            if (iframe) {
              iframe.onload = () => {
                this.loading = false;
                this.reloadDocument = false;
              };
            }
          }, 300);

          setTimeout(() => {
            if (this.loading) {
              if (retryCount < MAX_RETRIES) {
                console.warn(`Gview tardando demasiado. Reintentando... (Intento ${retryCount + 1})`);
                this.getFileAndPreview(retryCount + 1);
              } else {
                console.error("Gview falló al cargar después de varios intentos.");
                this.loading = false;
                this.reloadDocument = true;
              }
            }
          }, 4000);
        }
      } catch (error) {
        console.error("Error al obtener el archivo:", error);
        this.loading = false;
        this.reloadDocument = true;
      }
    }
  },
  computed: {},
  watch: {
    currentDocument(document) {
      if (document) {
        this.getFileAndPreview();
      } else {
        this.filePreview = null;
      }
    },
  },
};
</script>

<style></style>
